module.exports = __webpack_public_path__ + "static/media/ministerio_salud.3f24a878.png";